<app-dropdown-control
	[label]="label()"
	[controlName]="controlName()"
	[placeholder]="placeholder()"
	[required]="required()"
	[formGroup]="formGroup()"
	[options]="options()"
/>
